import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8010';

// Create axios instance with authentication
const createAuthenticatedRequest = () => {
  const token = localStorage.getItem('authToken');
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

// User Profile API
export const userProfileAPI = {
  // Get user profile with all GST numbers and addresses
  getProfile: async () => {
    const api = createAuthenticatedRequest();
    const response = await api.get('/user/profile');
    return response.data;
  },

  // Update user profile (phone, company address — not email)
  updateProfile: async (profileData) => {
    const api = createAuthenticatedRequest();
    const response = await api.put('/user/profile', profileData);
    return response.data;
  },

  changePassword: async ({ currentPassword, newPassword }) => {
    const api = createAuthenticatedRequest();
    const response = await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  // GST Numbers Management
  getGSTNumbers: async () => {
    const api = createAuthenticatedRequest();
    const response = await api.get('/user/gst-numbers');
    return response.data;
  },

  addGSTNumber: async (gstData) => {
    const api = createAuthenticatedRequest();
    const response = await api.post('/user/gst-numbers', gstData);
    return response.data;
  },

  updateGSTNumber: async (gstId, gstData) => {
    const api = createAuthenticatedRequest();
    const response = await api.put(`/user/gst-numbers/${gstId}`, gstData);
    return response.data;
  },

  deleteGSTNumber: async (gstId) => {
    const api = createAuthenticatedRequest();
    const response = await api.delete(`/user/gst-numbers/${gstId}`);
    return response.data;
  },

  // GST Addresses Management
  getGSTAddresses: async (gstId) => {
    const api = createAuthenticatedRequest();
    const response = await api.get(`/user/gst-numbers/${gstId}/addresses`);
    return response.data;
  },

  addGSTAddress: async (gstId, addressData) => {
    const api = createAuthenticatedRequest();
    const response = await api.post(`/user/gst-numbers/${gstId}/addresses`, addressData);
    return response.data;
  },

  updateGSTAddress: async (gstId, addressId, addressData) => {
    const api = createAuthenticatedRequest();
    const response = await api.put(`/user/gst-numbers/${gstId}/addresses/${addressId}`, addressData);
    return response.data;
  },

  deleteGSTAddress: async (gstId, addressId) => {
    const api = createAuthenticatedRequest();
    const response = await api.delete(`/user/gst-numbers/${gstId}/addresses/${addressId}`);
    return response.data;
  },

  // PAN Validation
  validatePAN: async (gstNumber) => {
    const api = createAuthenticatedRequest();
    const response = await api.post('/user/validate-pan', { gst_number: gstNumber });
    return response.data;
  },

  // GST Dropdown Options
  getGSTDropdownOptions: async () => {
    const api = createAuthenticatedRequest();
    const response = await api.get('/user/gst-dropdown-options');
    return response.data;
  }
};

export default userProfileAPI;
